<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">TP Benchmark - Usage Restriction Notice</h4>
</div>
<div class="modal-body ey-privacy-notice-welcomescreen-body">
  <div class="container-fluid">
    <div class="row">
            <div class="col-1 modal-exclamation" *ngIf="isGenerativeAiEnabled">
        <span class="material-icons check-icon-GenAI">check_circle</span>
      </div>
      <div class="col-11">
        <div class="body" *ngIf="isGenerativeAiEnabled">
          <p>
            <b>Audit Approved (Generative AI) Version</b>
          </p>
          <p>
            You are using the audit approved (generative AI) version of TP Benchmark, which is certified for use in assurance engagements, including tax provisions. Please acknowledge to proceed.
          </p>
        </div>
       </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 d-flex justify-content-center">
        <button *ngIf="isGenerativeAiEnabled"
                type="button"
                class="btn btn-primary"
                [disabled]="!isActive"
                (click)="acknowledge()"
                title="Please scroll to the bottom to acknowledge.">
          Acknowledge
        </button>
      </div>
    </div>
  </div>
</div>
